module.exports = __webpack_public_path__ + "static/media/masthead-augusta-margaret-river-times.34046b2c.svg";